// extracted by mini-css-extract-plugin
export default {"Container":"_Container--AM_Kb","Success":"_Success--wkzdy","Error":"_Error--iDSG_","Warning":"_Warning--B9cGS","Info":"_Info--yDmN_"};